/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverEarningRecalculateSourceAdminDto } from '../models/DriverEarningRecalculateSourceAdminDto';
import type { PostDriverEarningRecalculateSourceAdminRequest } from '../models/PostDriverEarningRecalculateSourceAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverEarningsRecalculationService {
    /**
     * **Required Policy:** `ReCalculateDriverEarnings`
     * @returns DriverEarningRecalculateSourceAdminDto OK
     * @throws ApiError
     */
    public static recalculateSourceAdmin({
        requestBody,
    }: {
        requestBody?: PostDriverEarningRecalculateSourceAdminRequest,
    }): CancelablePromise<DriverEarningRecalculateSourceAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driver-earnings/recalculate/source',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
